var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetDetermination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8700",
    "data-name": "Rectangle 8700",
    width: 16.737,
    height: 16.748,
    fill: "#0072ce"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Asset_Determination"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset_Determination",
    "data-name": "Asset # Determination",
    clipPath: "url(#clip-Asset_Determination)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11800",
    "data-name": "Group 11800",
    transform: "translate(0.631 0.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11799",
    "data-name": "Group 11799",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22265",
    "data-name": "Path 22265",
    d: "M1.315,8.867a7.3,7.3,0,0,0,.1.772A9.129,9.129,0,0,0,1.9,11.2a6.637,6.637,0,0,0,1.824,2.5,6.024,6.024,0,0,0,1.531,1.011,7.956,7.956,0,0,0,1.829.591,7.434,7.434,0,0,0,1.508.106,7.307,7.307,0,0,0,1.344-.156,5.887,5.887,0,0,0,1.238-.426c.059-.027.094-.032.121.042q.2.542.4,1.08c.028.073.016.1-.059.133a9.816,9.816,0,0,1-1.891.555,8.806,8.806,0,0,1-1.674.106,7.326,7.326,0,0,1-1.78-.25A8.616,8.616,0,0,1,3.365,15.1a6.916,6.916,0,0,1-1.333-1.215A9.054,9.054,0,0,1,.859,12.106a10.07,10.07,0,0,1-.6-1.6A7.207,7.207,0,0,1,0,8.379c.009-.314-.009-.629.028-.941A8.366,8.366,0,0,1,.289,6.126,8.889,8.889,0,0,1,.719,4.942,8.626,8.626,0,0,1,1.786,3.181a7.189,7.189,0,0,1,1.22-1.254A8.771,8.771,0,0,1,5.3.583,9.235,9.235,0,0,1,7.121.09a8.328,8.328,0,0,1,1.8-.073A8.024,8.024,0,0,1,11.694.7a9.286,9.286,0,0,1,1.888,1.128A6.642,6.642,0,0,1,14.788,2.99,8.616,8.616,0,0,1,16.072,5.1a9.137,9.137,0,0,1,.577,2.023,8.687,8.687,0,0,1,.049,2.07,8.057,8.057,0,0,1-.576,2.321c-.029.072-.027.18-.091.208s-.14-.049-.212-.076c-.3-.114-.6-.233-.909-.344-.092-.034-.1-.083-.065-.163a6.232,6.232,0,0,0,.465-1.515,7.33,7.33,0,0,0,.079-1.864,7.546,7.546,0,0,0-.293-1.5c-.053-.177-.139-.343-.2-.519a5.345,5.345,0,0,0-.724-1.373,6.852,6.852,0,0,0-4.84-2.955,9.284,9.284,0,0,0-1.548-.051,6.009,6.009,0,0,0-1.626.318,6.917,6.917,0,0,0-1.756.843A7.4,7.4,0,0,0,2.859,3.948,7.081,7.081,0,0,0,1.99,5.331a6.668,6.668,0,0,0-.646,2.1,7.059,7.059,0,0,0-.029,1.437",
    transform: "translate(0 0)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22266",
    "data-name": "Path 22266",
    d: "M44.405,39.787a4.652,4.652,0,0,1,2.147.473,5.164,5.164,0,0,1,2.2,2.078,4.661,4.661,0,0,1,.6,1.848,4.9,4.9,0,0,1-.407,2.594c-.034.077-.071.093-.156.065-.337-.112-.667-.241-1-.364-.155-.057-.147-.062-.08-.21a3.718,3.718,0,0,0,.314-1.133,3.6,3.6,0,0,0-.436-2.172,3.84,3.84,0,0,0-.888-1.018,3.094,3.094,0,0,0-1.266-.685,3.847,3.847,0,0,0-1.627-.089,3.485,3.485,0,0,0-1.385.527,4.208,4.208,0,0,0-.719.621,3.422,3.422,0,0,0-.883,1.872,3.515,3.515,0,0,0,.553,2.559,3.977,3.977,0,0,0,.848.887,3.391,3.391,0,0,0,1.628.7A3.625,3.625,0,0,0,46.024,48c.073-.036.1-.009.125.057q.209.554.425,1.106c.019.048.011.065-.038.086a5.47,5.47,0,0,1-1.724.461,4.693,4.693,0,0,1-1.712-.165A5.095,5.095,0,0,1,39.726,46.4a4.648,4.648,0,0,1-.257-1.105,4.85,4.85,0,0,1,.006-1.185,4.637,4.637,0,0,1,.581-1.735,5.6,5.6,0,0,1,1.377-1.6A5.457,5.457,0,0,1,42.2,40.3a4.712,4.712,0,0,1,1.558-.486,4.2,4.2,0,0,1,.652-.03",
    transform: "translate(-36.053 -36.373)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22267",
    "data-name": "Path 22267",
    d: "M121.45,125.206c-.2-.529-.383-1.041-.585-1.546-.379-.951-.728-1.914-1.1-2.868-.126-.325-.261-.647-.366-.979a7.717,7.717,0,0,0-.335-.873c-.012-.026-.027-.057-.006-.08s.045.005.066.013c.732.273,1.464.544,2.195.822.508.194,1.012.4,1.52.594.77.295,1.542.586,2.306.9.066.027.133.049.222.082l-.387.247c-.406.26-.81.521-1.218.778-.08.05-.036.086,0,.124.154.16.309.318.463.476q.631.647,1.263,1.294c.045.045.05.07,0,.118q-.517.5-1.028,1c-.057.056-.1.086-.157,0a1.415,1.415,0,0,0-.169-.164q-.81-.8-1.618-1.606c-.078-.078-.094-.007-.12.037q-.352.6-.7,1.2l-.249.432",
    transform: "translate(-108.837 -108.655)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22268",
    "data-name": "Path 22268",
    d: "M80.312,78.854a1.612,1.612,0,1,1-.008,3.224,1.573,1.573,0,0,1-1.6-1.625,1.6,1.6,0,0,1,1.613-1.6",
    transform: "translate(-71.948 -72.09)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetDetermination);
export default __webpack_public_path__ + "static/media/Asset Determination.988cf0acbeb74841f1e39e14f0c6fd74.svg";
export { ForwardRef as ReactComponent };